module.exports = __webpack_public_path__ + "static/persona-3-d9506d04fdeb00fe549de2f5ca4d6ed4.jpg";